import { useRemoteOperationsAreaOperatorRole } from '@backoffice-frontend/ad-remote-operations-area'
import type { FccOperatorRoleType } from '@backoffice-frontend/graphql'
import type { UseAlertsForRoleAdAlertFragment } from './useAlertsForRole.hook'

/**
 * Whether this alert is handled by the given role.
 *
 * Prefer useAlertsForRole; reach for this predicate only where a hook cannot be
 * called, such as inside a per-vehicle callback.
 */
export const isAlertVisibleToRole = (
  alert: UseAlertsForRoleAdAlertFragment,
  role: FccOperatorRoleType | undefined,
): boolean => !role || alert.visibleTo.includes(role)

/**
 * The alerts visible to the current area's operator role, in the order the
 * backend returned them.
 */
export const useAlertsForRole = <A extends UseAlertsForRoleAdAlertFragment>(
  alerts: A[] | undefined,
): A[] => {
  const role = useRemoteOperationsAreaOperatorRole()

  return (alerts ?? []).filter(alert => isAlertVisibleToRole(alert, role))
}
